var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSync2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68794 0H22.3121C24.3404 0 26 1.65957 26 3.68794V22.3121C26 24.3404 24.3404 26 22.3121 26H3.68794C1.65957 26 0 24.3404 0 22.3121V3.68794C0 1.65957 1.65957 0 3.68794 0Z",
    fill: "#0047AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3617 17.3333C19.2695 17.6099 19.0851 17.7943 18.8085 17.8865L9.49645 22.6809C9.40425 22.773 9.21986 22.6809 9.12766 22.5887V22.4965V22.4043V20.0993C9.12766 20.0993 9.12766 20.0993 9.12766 20.0071C9.12766 19.9149 9.21986 19.8227 9.31206 19.7305L15.6738 16.5035C16.0426 16.2269 16.2269 15.766 16.0426 15.305C15.9504 15.1206 15.8582 15.0284 15.6738 14.9362L8.02127 11.0638C7.56028 10.8794 7.37589 10.4184 7.37589 9.95745C7.37589 9.49645 7.65248 9.03546 8.02127 8.85106L17.3333 4.05674C17.4255 3.96454 17.6099 4.05674 17.7021 4.14894V4.24113V4.33333V6.6383C17.7021 6.6383 17.7021 6.6383 17.7021 6.7305C17.7021 6.82269 17.6099 6.91489 17.5177 7.00709L11.156 10.234C10.7872 10.5106 10.6028 10.9716 10.7872 11.4326C10.8794 11.617 10.9716 11.7092 11.156 11.8014L18.8085 15.6738C19.3617 16.0426 19.6383 16.6879 19.3617 17.3333Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync2);
export default __webpack_public_path__ + "static/media/Sync2_.57b55112f45d846db4a949ad2b224dfc.svg";
export { ForwardRef as ReactComponent };